import { Order } from "@today/api/taker"
import { getForwardingInvoiceNumber } from "."

type ExternalLinkReturn = {
  url: string
  label: string
}

export type ExternalLinkByForwardingNameByOrderPick = Pick<
  Order,
  "forwardingInfo" | "developerPayload"
>

export function externalLinkByForwardingName({
  developerPayload,
  forwardingInfo,
}: ExternalLinkByForwardingNameByOrderPick): ExternalLinkReturn {
  const forwardingInvoiceNumber =
    getForwardingInvoiceNumber({
      developerPayload,
      forwardingInfo,
    }) || ""
  // 수도권 전담 물품은 배송사가 투데이(TO_DAY)로 잡히지만 위탁 구간은 중개사가 운송한다.
  const forwardingInvoiceName =
    forwardingInfo?.deliveryOrganizationName === "HANJIN" ||
    forwardingInfo?.deliveryOrganizationName === "EMS"
      ? forwardingInfo.deliveryOrganizationName
      : forwardingInfo?.brokerOrganizationName

  if (forwardingInvoiceName === "HANJIN") {
    return {
      label: "한진택배 위탁구간 배송 상세정보 조회",
      url: `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&wblnumText2=${forwardingInvoiceNumber}&schLang=KR`,
    }
  } else if (forwardingInvoiceName === "EMS") {
    return {
      label: "우체국 배송 상세정보 조회",
      url: `https://service.epost.go.kr/trace.RetrieveEmsRigiTraceList.comm?POST_CODE=${forwardingInvoiceNumber}`,
    }
  } else {
    return {
      label: "이후 CJ 배송상태 조회",
      url: `https://trace.cjlogistics.com/web/detail.jsp?slipno=${forwardingInvoiceNumber}`,
    }
  }
}
